export enum NotificationStatus {
  New = 'New',
  Seen = 'Seen',
  Read = 'Read'
}
